// extracted by mini-css-extract-plugin
export var active = "_2f-9";
export var backButton = "_2f-8";
export var clone = "_2f-e";
export var collapseBar = "_2f-k";
export var collapseMode = "_2f-m";
export var collapsed = "_2f-o";
export var dimmed = "_2f-i";
export var dragHandle = "_2f-c";
export var dropdownIcon = "_2f-g";
export var expanding = "_2f-n";
export var hidden = "_2f-x";
export var iconContainer = "_2f-q";
export var iconSwapper = "_2f-w";
export var navItem = "_2f-6";
export var navItemIcon = "_2f-f";
export var navProfile = "_2f-7";
export var notificationCountBadge = "_2f-j";
export var notificationDot = "_2f-r";
export var optionsContainer = "_2f-h";
export var primaryNav = "_2f-0";
export var primaryNavDivider = "_2f-v";
export var primaryNavResizeHandle = "_2f-2";
export var primaryNavResizing = "_2f-1";
export var primaryNavTabSection = "_2f-u";
export var primaryTab = "_2f-p";
export var primaryTabIconBox = "_2f-s";
export var secondaryNav = "_2f-3";
export var selected = "_2f-t";
export var settingsNav = "_2f-4";
export var settingsNavItems = "_2f-5";
export var show = "_2f-d";
export var sideNav = "_2f-l";
export var teamItem = "_2f-a";
export var userProfileItem = "_2f-b";